// extracted by mini-css-extract-plugin
export default {"image":"PageNotFound_image__zapzn"};